import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { baseAPI } from '../../config';
import Header from './components/Header';
import Footer from './components/Footer';
import SecurePaymentInterface from './components/SecurePaymentInterface';
import BankTransferInterface from './components/BankTransferInterface';

const LandingPaymentPage = () => {
  const { id } = useParams();
  const [importeDeuda, setImporteDeuda] = useState(null);
  const [divisa, setDivisa] = useState('EUR');
  const [urlPagoPropiaCliente, setUrlPagoPropiaCliente] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) {
      setError('ID inválido');
      setIsLoading(false);
      return;
    }
    const fetchData = async () => {
      let source = 'not defined';
      const currentUrl = window.location.href;
      if (currentUrl.includes('sms')) source = 'sms';
      else if (currentUrl.includes('email')) source = 'email';
      else if (currentUrl.includes('chat')) source = 'chat';

      try {
        const { data } = await axios.get(`${baseAPI}/info/expedient/${id}`, {
          params: {
            source,
          },
        });
        setImporteDeuda(data?.importe_deuda ?? null);
        setDivisa(data?.divisa || 'EUR');
        setUrlPagoPropiaCliente(data?.url_pago_propia_cliente || null);
      } catch (e) {
        setError('No se pudo cargar el importe de la deuda');
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const formatAmount = (value, currencyCode) => {
    if (typeof value !== 'number') return '—';
    try {
      return new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: currencyCode || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (e) {
      return `${value.toFixed(2)} €`;
    }
  };

  if (isLoading) {
    return <div>Cargando...</div>;
  }

  return (
    <div className='min-h-screen bg-white'>
      {/* Header */}
      {urlPagoPropiaCliente && !error ? (
        <Header title='Plataforma de Pago Seguro' subtitle='Tu seguridad es nuestra prioridad' />
      ) : (
        <Header
          title='Instrucciones de pago'
          subtitle='Consulta el importe pendiente y realiza tu pago de forma segura'
        />
      )}

      {/* Content */}
      {urlPagoPropiaCliente && !error ? (
        <SecurePaymentInterface
          importeDeuda={importeDeuda}
          divisa={divisa}
          formatAmount={formatAmount}
          urlPagoPropiaCliente={urlPagoPropiaCliente}
          id={id}
        />
      ) : (
        <BankTransferInterface
          importeDeuda={importeDeuda}
          divisa={divisa}
          formatAmount={formatAmount}
          isLoading={isLoading}
          error={error}
        />
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPaymentPage;
